<template>
  <div class="page-content">
    <VehiclesComponent />
  </div>
</template>

<script>
import VehiclesComponent from '../components/VehiclesComponent.vue'

export default {
  name: 'Vehicles',
  components: {
    VehiclesComponent
  }
}
</script>

<style scoped>
.page-content {
  flex: 1;
  display: flex;
  width: 100%;
  height: 100%;
  position: relative;
}
</style>
